import { useMemo } from 'react';
var useFloatingButton = function (hasPermission, onClick, options) {
    return useMemo(function () {
        if (!hasPermission)
            return;
        return {
            onClick: onClick,
            options: options,
        };
    }, [hasPermission, onClick, options]);
};
export default useFloatingButton;
